ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
{ BillableGuestsAlert } = require 'app/common/components/billable-guests-alert'
BillableGuestListPopoverView = require 'app/scripts/views/board/billable-guest-list-popover-view'
BoardOrgSelectPermLevelView = require 'app/scripts/views/board-menu/board-org-select-perm-level-view'
ChangeBoardOrgTemplate = require 'app/scripts/views/templates/popover_change_board_org'
Confirm = require 'app/scripts/views/lib/confirm'
CreateOrgView = require 'app/scripts/views/organization/create-org-view'
{ BoardInviteRestrictValues } = require 'app/scripts/views/organization/constants'
ModelLoader = require 'app/scripts/db/model-loader'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
ReactDOM = require 'react-dom'
React = require 'react'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
_ = require 'underscore'
isDesktop = require('@trello/browser').isDesktop()

module.exports = class BoardSelectOrganizationView extends View

  viewTitleKey: 'change organization'

  events:
    'click .js-submit': 'submit'
    'change .js-org': 'orgSelected'
    'click .js-new-org': 'newOrg'

  initialize: ->
    @makeDebouncedMethods 'render'
    @haveAvailableLicenses = true
    @listenTo @model, 'change:memberships', @updateOrgOptions

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

  getTemplateData: ->
    data = @model.toJSON { org: true }
    orgs = if @model.owned() then Auth.me().organizationList.models else []
    showFeature = featureFlagClient.get('enterprise.restrict-moves-and-copies-into-teams-within-enterprise', false)
    if @model.hasEnterprise() && showFeature
      data.hasEnterprise = true
      orgs = _.filter(orgs, (org) -> org.get('idEnterprise') == data.org.idEnterprise)
      data.enterpriseName = @model.getEnterprise()?.get('displayName')
    data.orgs = (org.toJSON() for org in orgs)
    data.hasOrgs = data.orgs.length != 0
    data.isDesktop = isDesktop

    currentSelection = @selectedOrganization || data.idOrganization

    if currentSelection
      for org in data.orgs
        if org.id == currentSelection
          org.select = true

    data.isPrivate = @model.isPrivate()
    data.isTemplate = @model.isTemplate() && @templateFlagEnabled
    data.allowsSelfJoin = @model.allowsSelfJoin()

    data.addToTeam = false

    return data

  render: ->
    data = @getTemplateData()

    @$el.html(
     ChangeBoardOrgTemplate(data)
    )

    @updateOrgOptions()
    @

  remove: ->
    if @reactRoot
      ReactDOM.unmountComponentAtNode(@reactRoot)
    super

  showOrgBoardVisPerms: (organization, idOrganizationSource) ->
    PopOver.pushView
      view: new BoardOrgSelectPermLevelView({ @model, organization, idOrganizationSource, @modelCache })

  changeOrg: (idOrganizationTarget, idOrganizationSource) ->
    orgChanged = idOrganizationTarget != idOrganizationSource

    # We aren't subscribed to the boards or the orgs, so we manually update the
    # client-side boardLists
    if orgChanged && idOrganizationSource
      # We may not be able to load the source organization model
      @modelCache.get('Organization', idOrganizationSource)?.boardList.remove(@model)

    settings = {}

    settings.idOrganization = idOrganizationTarget

    if idOrganizationTarget
      # If we're switching to an organization, we might set additional org
      # friendly permissions.

      # We only show this checkbox if the board is currently private, so it's
      # only used to make a private -> org transition, and if it isn't checked
      # there isn't any change being made
      if @$('.js-make-org-visible').is(':checked')
        settings["prefs/permissionLevel"] = 'org'

      # We only display this checkbox if the org isn't currently org joinable
      # If it isn't checked then there's no change being made to the org
      if @$('.js-make-org-joinable').is(':checked')
        settings["prefs/selfJoin"] = true
    if orgChanged && idOrganizationTarget
      targetOrg = @modelCache.get('Organization', idOrganizationTarget)
      settings.keepBillableGuests = targetOrg?.owned() && @haveAvailableLicenses  && !isDesktop

    @model.update(settings)

    targetOrg?.boardList.add(@model)

    PopOver.hide()

  newOrg: (e) ->
    track("Board Header", "Add to a Team menu", "New Org")
    Util.stop(e)

    restrictToEnterpriseTeamCreation = featureFlagClient.get(
      'enterprise.prevent-enterprise-paid-members-from-creating-non-enterprise-teams',
      false,
    )
    if restrictToEnterpriseTeamCreation && Auth.me().isPaidManagedEntMember()
      createOpts = { boardToAddToOrg: @model, isEnterprise: true }
    else
      createOpts = { boardToAddToOrg: @model }

    trackingOpts = { category: 'board', method: 'by clicking create team in board change team menu' }

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })

  canAddToOrg: (organizationTarget) ->
    organizationTarget.canAddBoard(@model)

  submit: (e) ->
    if @$('.js-submit').hasClass('disabled')
      Util.stop(e)
      return

    @$('.js-submit').prop('disabled', true).toggleClass('disabled', true)

    Util.stop(e)
    track("Board", "Change Org")
    idOrganizationTarget = @$('.js-org').val()
    idOrganizationSource = @model.get('idOrganization')
    organizationTarget = @modelCache.get('Organization', idOrganizationTarget)

    Promise.try =>
      targetMembershipRestricted =
        (organizationTarget && organizationTarget.boardMembershipRestricted())

      if !targetMembershipRestricted
        return

      boardInviteRestrict = organizationTarget.getPref('boardInviteRestrict')
      filterRestrictedMembers = (member) ->
        switch boardInviteRestrict
          when BoardInviteRestrictValues.ORG
            !organizationTarget.isMember(member)
          when BoardInviteRestrictValues.MANAGED
            !member.isManagedEntMemberOf(organizationTarget.get('idEnterprise'))
          when BoardInviteRestrictValues.ORG_OR_MANAGED
            !organizationTarget.isMember(member) && !member.isManagedEntMemberOf(organizationTarget.get('idEnterprise'))

      ModelLoader.loadOrganizationMembersData idOrganizationTarget
      .then =>
        restrictedMembers = @model.memberList.chain()
          .filter (member) -> filterRestrictedMembers(member)
          .map (member) -> member.get('fullName')
          .value()

        count = restrictedMembers.length

        if count == 0
          return

        confirmKey = switch boardInviteRestrict
          when BoardInviteRestrictValues.ORG
            if count == 1
              'external member not allowed'
            else
              'external members not allowed'
          when BoardInviteRestrictValues.MANAGED
            if count == 1
              'non managed member not allowed'
            else
              'non managed members not allowed'
          when BoardInviteRestrictValues.ORG_OR_MANAGED
            if count == 1
              'external and non managed member not allowed'
            else
              'external and non managed members not allowed'

        Promise.fromNode (next) =>
          Confirm.toggle confirmKey,
            elem: e.currentTarget
            model: @model
            confirmBtnClass: 'negate'
            templateData: {
              count: String(count)
              members:
                if restrictedMembers.length > 20
                  _.first(restrictedMembers, 20).join(', ') + '…'
                else
                  restrictedMembers.join(', ')
              team: organizationTarget.get('displayName')
            }
            fxConfirm: =>
              next()
            fxCancel: =>
              next(new Error('cancelled'))

    .then =>
      if organizationTarget && (
          organizationTarget.isFeatureEnabled('restrictVis') || @model.getPref('permissionLevel') == 'enterprise'
        )
        ModelLoader.loadOrganizationMembersData idOrganizationTarget
        .then =>
          if @canAddToOrg(organizationTarget)
            @changeOrg(idOrganizationTarget, idOrganizationSource)
          else
            @showOrgBoardVisPerms(organizationTarget, idOrganizationSource)
          return
        .done()
      else
        @changeOrg(idOrganizationTarget, idOrganizationSource)
    .error(->)
    .done()

  allowBoardCreate: ->
    @$('.js-submit').removeClass('disabled')
    @$('.js-board-limits-upgrade-ad').addClass('hide')
    @$('.js-permissions').removeClass('hide')

  updateOrgOptions: ->
    @$('.js-submit').addClass('disabled')
    @$('.js-billable-guests-warning').addClass('hide')

    @selectedOrganization = @$('.js-org').val()
    hasOrgSelected = @selectedOrganization != ''

    @$('.js-make-org-visible,.js-make-org-joinable')
    .closest('.js-check-div')
    .toggleClass('hide', !hasOrgSelected)

    if !hasOrgSelected
      @hideSpinner()
      @allowBoardCreate()
      return

    @showSpinner()

    if @model.get('idOrganization') == @selectedOrganization
      @hideSpinner()
      @allowBoardCreate()
      return

    Promise.all [
      ApiPromise
        type: 'GET'
        url: "/1/organizations/#{@selectedOrganization}/newBillableGuests/#{@model.id}"
      ModelLoader.loadOrganizationMembersMinimalWithAvailableLicenseCount(@selectedOrganization)
    ]
    .spread (newBillableGuests, org) =>
      # Show the 'new' board limits CTA
      if org?.isAtOrOverFreeBoardLimit()
        @$('.js-board-limits-upgrade-ad').removeClass('hide')
        @$('.js-permissions').addClass('hide')
        @$('.js-target-team').text(org.get('displayName'))
        @$('.js-upgrade-link').attr('href', org.getBillingUrl())
        @hideSpinner()

      # Show the new billable guests information
      else if newBillableGuests.length > 0
        @renderBillableGuestAlert({ org, newBillableGuests })
        @haveAvailableLicenses = newBillableGuests.length <= org.getAvailableLicenseCount()

      else
        @allowBoardCreate()
    .finally =>
      @hideSpinner()

  renderBillableGuestAlert: ({ org, newBillableGuests }) ->
    productCode = org.get('paidAccount')?.products?[0]
    props =
      adminNames: org.adminList.map((member) -> member.get('fullName') || member.get('username'))
      newBillableGuestsCount: newBillableGuests.length
      availableLicenseCount: org.getAvailableLicenseCount()
      orgName: org.get('displayName') || org.get('name')
      pricePerGuest: OrgFeatures.getPrice(productCode)
      isMonthly: OrgFeatures.isMonthly(productCode)
      isOrgAdmin: org.owned()
      orgUrl: org.url
      isReopen: false
      isDesktop: isDesktop
      onCountClick: => PopOver.pushView {
        view: new BillableGuestListPopoverView({ newBillableGuests })
      }

    Element = React.createElement BillableGuestsAlert, props
    @reactRoot = @$('.js-billable-guests-warning')[0]
    ReactDOM.render Element, @reactRoot
    @$('.js-billable-guests-warning').removeClass('hide')
    @allowBoardCreate()

  orgSelected: (e) ->
    @updateOrgOptions()

  showSpinner: ->
    @$('.js-loading').toggleClass('hide', false)
    @$('.js-loaded').toggleClass('hide', true)

  hideSpinner: ->
    @$('.js-loading').toggleClass('hide', true)
    @$('.js-loaded').toggleClass('hide', false)
